import React from 'react'
import type { Icon } from 'shared/utils'

const Suitcase = (props: Icon) => {
    const {
        color = 'black',
        width = 177,
        height = 151,
        className = 'suitcase'
    } = props
    return (
        <svg width={width} height={height} fill={color} className={className}>
            <path
                d="M9 91c6.621 2.03 13.693 3.738 21.053 5.248v14.168h25.262v-10.233A310.292 310.292 0 0 0 89 102.02c11.623 0 22.89-.657 33.684-1.837v10.233h25.263V96.248c7.36-1.51 14.43-3.218 21.053-5.248v53H9V91zm122 10h9V84h-9v17zm-93 0h9V84h-9v17zM9 38h160v43.431c-6.56 2.124-13.619 3.964-21.053 5.553V76.077h-25.262v15.006A299.066 299.066 0 0 1 89 93c-11.653 0-22.922-.696-33.684-1.917V76.077H30.053v10.907C22.619 85.395 15.56 83.554 9 81.43V38zm46-9h67V9H55v20zM46.357 0v29.361H0V151h177V29.361h-46.357V0H46.357z"
                fillRule="evenodd"
                opacity={0.2}
            />
        </svg>
    )
}

export { Suitcase }
